import { render, staticRenderFns } from "./Fight.vue?vue&type=template&id=6ce4b346&scoped=true&"
import script from "./Fight.vue?vue&type=script&lang=js&"
export * from "./Fight.vue?vue&type=script&lang=js&"
import style0 from "./Fight.vue?vue&type=style&index=0&id=6ce4b346&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce4b346",
  null
  
)

export default component.exports